import { Injectable } from '@angular/core';
import { State, Action, StateContext } from '@ngxs/store';
import { GenderActions } from './gender.actions';
import { Gender } from '../../models/gender.model';
import { GenderService } from '../../services/gender.service';
import { LocalizationService } from 'src/app/services/localization/localization.service';
import { AlertService } from '../alert/alert.service';
import { MappingUtilsService } from 'src/app/services/utils/mapping-utils.service';

export class GenderStateModel {
  public genders: Gender[];
  public error: string;
}

const defaults = {
  genders: [],
  error: ''
};

@State<GenderStateModel>({
  name: 'gender',
  defaults
})
@Injectable()
export class GenderState {

  constructor(
    private alertService: AlertService,
    private localizationService: LocalizationService,
    private genderService: GenderService
  ) { }

  @Action(GenderActions.GetGenders)
  getGenders(ctx: StateContext<GenderStateModel>, { }: GenderActions.GetGenders) {
    return this.genderService.getGenders().subscribe({
      next: (genders: Gender[]) => {
        ctx.dispatch(new GenderActions.GetGendersSuccess(genders));
      },
      error: (error) => {
        ctx.dispatch(new GenderActions.GetGendersFail(error));
      }
    });
  }

  @Action(GenderActions.GetGendersSuccess)
  getGendersSuccess(ctx: StateContext<GenderStateModel>, { genders }: GenderActions.GetGendersSuccess) {
    ctx.patchState({
      genders: genders
    });
  }

  @Action(GenderActions.GetGendersFail)
  getGendersFail(ctx: StateContext<GenderStateModel>, { error }: GenderActions.GetGendersFail) {
    ctx.patchState({
      error: error,
    });
    MappingUtilsService.showError(this.getTitle(), error, this.alertService, this.localizationService);
  }

  private getTitle() {
    return this.localizationService.translate('gender.title');
  }
}
